import images from "./images";

const home = [
  {
    id: 1,
    image: images.home1,
    subtitle: "Welcome to CampFire",
    title: "Embark on Nature's Blissful Trails",
    buttonText: "Our Tours",
    buttonLink: "Tours",
  },
  {
    id: 2,
    image: images.home2,
    subtitle: "Welcome to CampFire",
    title: "Discover The Thrills of Camping Adventures",
    buttonText: "Our Tours",
    buttonLink: "Tours",
  },
  {
    id: 3,
    image: images.home3,
    subtitle: "Welcome to CampFire",
    title: "Experience The Joy of Trekking Exploration",
    buttonText: "Our Tours",
    buttonLink: "Tours",
  },
];

export default home;
